import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { putRegisterName } from '../../../api/login'
import { ReactComponent as Checkmark } from '../../../assets/icons/checkmark.svg'
import { ReactComponent as Pencil } from '../../../assets/icons/pencil.svg'
import { useUserProfileStore } from '../../../stores/userProfileStore'
import { getRole } from '../../../utils/auth'

import styles from './username.module.scss'

function Username() {
    const { t } = useTranslation()

    const [{ userProfile }, { editMyProfileName }] = useUserProfileStore()
    const { username, role } = userProfile

    const [isEditing, setIsEditing] = useState(false)
    const [newUsername, setNewUsername] = useState(username)

    const inputRef = useRef<HTMLInputElement>(null)

    useEffect(() => {
        if (isEditing) {
            inputRef?.current?.focus()
        }
    }, [isEditing])

    useEffect(() => {
        setNewUsername(username)
    }, [username])

    const handleSubmit = () => {
        setIsEditing(false)
        putRegisterName(userProfile?.email || '', newUsername).then(() => {
            editMyProfileName(newUsername)
        })
    }

    return (
        <>
            {isEditing ? (
                <form className={styles.username__form} onSubmit={handleSubmit}>
                    <input
                        ref={inputRef}
                        className={styles.username__input}
                        type="text"
                        placeholder={t('name')}
                        value={newUsername}
                        onChange={(e) => setNewUsername(e.target.value)}
                    />
                    <button className={styles.username__btn} type="submit">
                        <Checkmark className={styles.username__icon} />
                    </button>
                </form>
            ) : (
                <div className={styles.username__wrapper}>
                    <button
                        className={styles.username__btn}
                        onClick={() => setIsEditing(true)}
                    >
                        <Pencil className={styles.username__icon} />
                    </button>
                    <div className={styles.username__content}>{username}</div>
                    <div className={styles.username__role}>{getRole(role)}</div>
                </div>
            )}
        </>
    )
}

export default Username
